import type { Ref } from 'react';

// ─────────────────────────────────────────────────────────────
// Pied de liste pour le chargement progressif / pagination.
// Affiche un bouton « Charger plus », un compteur et une sentinelle
// invisible qui déclenche le chargement automatique au défilement.
// ─────────────────────────────────────────────────────────────

interface ProgressiveFooterProps {
  hasMore: boolean;
  shown: number;
  total: number;
  remaining: number;
  loadMore: () => void;
  sentinelRef: Ref<HTMLDivElement>;
  /** Libellé des éléments, ex. « annonces », « produits ». */
  label?: string;
}

export default function ProgressiveFooter({
  hasMore,
  shown,
  total,
  remaining,
  loadMore,
  sentinelRef,
  label = 'éléments',
}: ProgressiveFooterProps) {
  if (total === 0) return null;

  return (
    <div className="mt-8 flex flex-col items-center gap-3">
      {/* Sentinelle de défilement infini (invisible). */}
      <div ref={sentinelRef} aria-hidden="true" className="h-px w-full"></div>

      {hasMore ? (
        <>
          <button
            type="button"
            onClick={loadMore}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-add-line"></i>
            Charger plus
            <span className="text-background-50/70 font-normal">
              ({remaining} {label} restant{remaining > 1 ? 's' : ''})
            </span>
          </button>
          <p className="text-[11px] text-foreground-400">{shown} sur {total} affichés</p>
        </>
      ) : (
        <p className="text-[11px] text-foreground-400 flex items-center gap-1.5">
          <i className="ri-check-double-line"></i>
          Vous avez tout vu · {total} {label}
        </p>
      )}
    </div>
  );
}